import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Emkan1 from "../../assets/pic/tools/1.jpg"
import Emkan2 from "../../assets/pic/tools/2.jpg"
import Emkan3 from "../../assets/pic/tools/3.png"
import Emkan4 from "../../assets/pic/tools/4.png"
import Emkan5 from "../../assets/pic/tools/5.jpg"
import Emkan6 from "../../assets/pic/tools/6.png"
import Emkan7 from "../../assets/pic/tools/7.jpg"
import Emkan8 from "../../assets/pic/tools/8.png"
import Emkan9 from "../../assets/pic/tools/9.jpg"
import Emkan10 from "../../assets/pic/tools/10.jpg"
import Emkan11 from "../../assets/pic/tools/11.jpg"
import Emkan12 from "../../assets/pic/tools/12.jpg"
import Emkan13 from "../../assets/pic/tools/13.png"

const ToolsEn = ()=>{
    return(
        <div className='tools-wrap'>
            <Nav/>
            <div className="tools-dec">
                <h1>BellMeet facilities</h1>
                <br/>
                <h2>Talk to thousands of people from all over the world</h2>
                <p>
                    BellMeet is a comprehensive platform with which you can easily communicate with thousands of people with only a few clicks. Whatever you want is available to you; Audio and video communication, screen sharing, file sharing, whiteboard, online chat and more.
                </p>
                <img src={Emkan1} alt="person"/>
                <h2>No need to be installed</h2>
                <p>
                    BellMeet comprehensive platform, is a web-based application which requires no installation on the user’s device, this platform is easily accessable through any browser on any device and operating system.
                </p>
                <img src={Emkan2} alt="Os"/>
                <h2>Compatible with different devices</h2>
                <p>
                    BellMeet comprehensive platform is a web application and it is compatible with any device such as PC, laptop, tablet, mobile phone, smart TV and any operating system such as Windows, MacOS, Linux, Android, iOS.
                </p>
                <img className="png" src={Emkan3} alt="device"/>
                <h2>Online Chat</h2>
                <p>
                    BellMeet users can easily chat with one another. They can ask their questions and answer others’ questions.
                </p>
                <img className="png" src={Emkan4} alt="Chat"/>
                <h2>Announcements</h2>
                <p>
                    Do you have a large audience in your meetings?
                    <br/>
                    Advertise smartly and make money!
                    <br/>
                    By pinning a message or text in the announcements section, display it as a subtitle in your meetings.
                </p>
                <img src={Emkan5} alt="notification"/>
                <h2>Easy user management (Group access)</h2>
                <p>
                    There is no need to spend a lot of time on giving access to each user one by one! Easily manage and set the permissions of all users present at the meeting together at once.
                </p>
                <img className="png" src={Emkan6} alt="group access"/>
                <h2>No meeting will be missed</h2>
                <p>
                    Whether you are a presenter or a user; BellMeet comprehensive platform is completely compatible with mobile phones and you can easily join an E-meeting in any situation and with any type of internet service.
                </p>
                <img src={Emkan7} alt=""/>
                <h2>Forget about chalk and marker and write infinitely</h2>
                <p>
                    Easily bring whatever you have in mind to the online whiteboard. This board is fully compatible with hand touch, mouse pointer and light pens.
                </p>
                <img className="png" src={Emkan8} alt=""/>
                <h2>Share webcams without any limitations</h2>
                <p>
                    Connect with thousands of users via video. In BellMeet comprehensive platform, it is possible to share the webcam of all users at the same time.
                </p>
                <img src={Emkan9} alt=""/>
                <h2>Sharing files</h2>
                <p>
                    Stay up to date and use online content…
                    <br/>
                    By uploading  files and sharing them with the users present at the meeting, increase the efficiency of your meeting, assign homework to students provide your colleagues with the meeting documents, publish pamphlets and, etc.
                </p>
                <img src={Emkan10} alt=""/>
                <h2>Writing on files</h2>
                <p>
                    Easily display the uploaded pictures and PDF files in the meeting environment and make your desired nges. Highlight important points, fill in tables, analyze graphs, solve problems, etc.
                </p>
                <img src={Emkan11} alt=""/>
                <h2>Playing videos</h2>
                <p>
                    Easily display your high quality videos with high quality in the meeting environment and let users download them.
                </p>
                <img src={Emkan12} alt=""/>
                <h2>Share whatever you want with users</h2>
                <p>
                    You can easily achieve all your E-meeting goals by using the share screen feature.
                </p>
                <img className="png" src={Emkan13} alt=""/>
            </div>
            <Footer/>
        </div>
    )
}

export default ToolsEn